module.exports = __webpack_public_path__ + "media/images/current-7f915f2652ad99434c1956a6a4404fec.png";